import { cn } from '@/lib/utils';
import { TOCItem } from '@/lib/markdown-utils';

interface ManualTOCProps {
  items: TOCItem[];
  onItemClick: (anchor: string) => void;
  activeAnchor?: string;
  className?: string;
}

export function ManualTOC({ items, onItemClick, activeAnchor, className }: ManualTOCProps) {
  if (items.length === 0) return null;

  return (
    <nav className={cn("space-y-1", className)} aria-label="Sumário">
      <p className="text-xs font-semibold text-muted-foreground mb-2 uppercase tracking-wider">
        Sumário
      </p>
      <ul className="space-y-1">
        {items.map((item) => (
          <li key={item.anchor}>
            <button
              onClick={() => onItemClick(item.anchor)}
              className={cn(
                "text-sm w-full text-left py-1 px-2 rounded-md transition-colors hover:bg-muted",
                item.level === 3 && "pl-4 text-xs",
                activeAnchor === item.anchor && "bg-muted text-primary font-medium"
              )}
            >
              {item.text}
            </button>
          </li>
        ))}
      </ul>
    </nav>
  );
}
